import { HashLoader } from 'react-spinners';

const WholeLoading = () => {
    
    return (
        <div className='loading_container grid-animation'>
            <div className='h-full content-center'>
                <HashLoader
                    color="#000000"
                    cssOverride={{margin: 'auto'}}
                    size={50}
                    speedMultiplier={0.8}
                    margin={5}
                />
                <div className='loading_text'>
                    <span> 처리 중 입니다. </span>
                </div>
            </div>
        </div>
    )
}

export default WholeLoading;